import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngxs/store';
import { AuthState } from 'src/app/auth/state/auth/auth.state';

const npsSurveyLink = 'https://www.research.net/r/BKTXJMC';

export interface NpsDialogData {
  surveyGroupName?: string;
  surveyEmail?: string;
}

@Component({
  selector: 'app-nps-dialog',
  templateUrl: './nps-dialog.component.html',
  styleUrls: ['./nps-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NpsDialogComponent implements OnInit {

  settings: NpsDialogData;

  get src(): SafeResourceUrl {
    // generate url w/ params
    const { surveyGroupName, surveyEmail } = this.settings;

    const url = `${npsSurveyLink}?Org=${surveyGroupName}&Email=${surveyEmail}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<NpsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: NpsDialogData,
    private sanitizer: DomSanitizer
  ) {
    const profile = this.store.selectSnapshot(AuthState.getUserProfile);
    this.settings = {
      surveyEmail: profile ? profile.email : '',
      ...this.data
    };
  }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
